import { Amplify } from 'aws-amplify';

/**
 * Configure AWS Amplify with Cognito User Pool and Google OAuth.
 *
 * Note: We intentionally omit identityPoolId here. The app uses JWT tokens
 * (via API Gateway Cognito authorizer) for all API calls, not IAM credentials.
 * Including the Identity Pool causes 400 errors for Google-federated users
 * because the Identity Pool provider mapping doesn't cover social sign-in tokens.
 */
export function configureAmplify(): void {
  const isLocalhost = window.location.hostname === 'localhost';
  const redirectUrl = isLocalhost
    ? 'http://localhost:3000/'
    : 'https://app.reflysim.com/';

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
        userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '',
        loginWith: {
          oauth: {
            domain: import.meta.env.VITE_COGNITO_DOMAIN ?? 'reflysim.auth.us-east-1.amazoncognito.com',
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [redirectUrl],
            redirectSignOut: [redirectUrl],
            responseType: 'code',
            providers: ['Google'],
          },
        },
      },
    },
  });
}

export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT ?? '';
